"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpMagnaOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M26 25V7h-9V4h1V2H8v2h1v4a9 9 0 000 16.1V28H8v2h10v-2h-1v-3zM11 4h4v3h-2a8.76 8.76 0 00-2 .23zM6 16a7 7 0 017-7h11v14H13a7 7 0 01-7-7zm9 12h-4v-3.23a8.76 8.76 0 002 .23h2z" })));
}
exports.default = SvgPumpMagnaOutline;
//# sourceMappingURL=PumpMagnaOutline.js.map